import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminAreaApi as n } from "@maat/api-main";
//#region src/areas/admin/useAdminAreaTypesQuery.ts
var r = () => t({
	queryKey: e.types(),
	queryFn: () => n.listAreaTypes()
});
//#endregion
export { r as useAdminAreaTypesQuery };
